/**
 * @format
 */
const PartnerSurveysOverviewPage = () =>
    import('@/views/partner-survey/partner-survey-overview-page-view');
const PartnerSurveyIndex = () => import('@/views/partner-survey/partner-survey-index-view');
const PartnerSurveyDesign = () =>
    import('@/views/partner-survey-design/partner-survey-design-view');
const PartnerSurveyEmailEditView = () =>
    import('@/views/partner-survey-design/partner-survey-email-edit-view');
const PartnerSurveySubmissionForm = () =>
    import('@/views/partner-survey/partner-survey-submission-form-view');
const PartnerSurveyPreviewForm = () =>
    import('@/views/partner-survey/partner-survey-preview-form-view');
export default [
    {
        path: '/PartnerSurveys',
        name: 'PartnerSurveys',
        component: PartnerSurveyIndex,
        meta: {
            isUiShown: true,
            pageClass: 'partner-survey-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Account/PartnerSurveys',
        name: 'PartnerSurveysAccount',
        component: PartnerSurveyIndex,
        meta: {
            type: 'client',
            isUiShown: true,
            pageClass: 'partner-survey-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/PartnerSurveys/:partnerSurveyId/Overview',
        name: 'PSOverviewPage',
        component: PartnerSurveysOverviewPage,
        meta: {
            isUiShown: true,
            pageClass: 'agency-overview-page-view',
            pageTitle: 'Partner Surveys Overview page',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/PartnerSurveys/:partnerSurveyId/Design',
        name: 'PartnerSurveyDesign',
        component: PartnerSurveyDesign,
        meta: {
            isUiShown: false,
            pageClass: 'survey-design-view',
            pageTitle: 'Survey Builder',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/PartnerSurveys/:partnerSurveyId/EmailEditor',
        name: 'PartnerSurveyEmailEditor',
        component: PartnerSurveyEmailEditView,
        meta: {
            isUiShown: false,
            pageClass: 'survey-email-edit-view',
            pageTitle: 'Survey Email Editor',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/PartnerSurvey/:instanceId/Submission',
        name: 'PartnerSurveySubmissionForm',
        component: PartnerSurveySubmissionForm,
        props: true,
        meta: {
            isUiShown: false,
            pageClass: 'psurvey-submission-form',
            pageTitle: 'Partner Survey',
        },
    },
    // AGENCY
    {
        path: '/Agencies/:agencyId/PartnerSurveys',
        name: 'PartnerSurveysAgency',
        component: PartnerSurveyIndex,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'partner-survey-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Agencies/:agencyId/PartnerSurveys/:surveyId/Preview',
        name: 'PartnerSurveyPreviewAgency',
        component: PartnerSurveyPreviewForm,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'partner-survey-preview-form-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/PartnerSurveys/:surveyId/Preview',
        name: 'PartnerSurveyPreview',
        component: PartnerSurveyPreviewForm,
        meta: {
            type: 'agency',
            isUiShown: true,
            pageClass: 'partner-survey-preview-form-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Agencies/:agencyId/PartnerSurveys/:partnerSurveyId/Overview',
        name: 'PSOverviewPageAgency',
        component: PartnerSurveysOverviewPage,
        meta: {
            type: 'Agency',
            isUiShown: true,
            pageClass: 'agency-overview-page-view',
            pageTitle: 'Partner Surveys Overview page',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Agencies/:agencyId/PartnerSurveys/:partnerSurveyId/Design',
        name: 'PartnerSurveyDesignAgency',
        component: PartnerSurveyDesign,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'survey-design-view',
            pageTitle: 'Survey Builder',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Agencies/:agencyId/PartnerSurveys/:partnerSurveyId/EmailEditor',
        name: 'PartnerSurveyEmailEditorAgency',
        component: PartnerSurveyEmailEditView,
        meta: {
            type: 'agency',
            isUiShown: false,
            pageClass: 'survey-email-edit-view',
            pageTitle: 'Survey Email Editor',
            subtype: 'partner-surveys',
        },
    },
    // CLIENT
    {
        path: '/Clients/:clientId/Account/PartnerSurveys',
        name: 'ClientPartnerSurveysAccount',
        component: PartnerSurveyIndex,
        meta: {
            type: 'client',
            isUiShown: true,
            pageClass: 'partner-survey-view',
            pageTitle: 'Partner Surveys',
            subtype: 'partner-surveys',
        },
    },
    {
        path: '/Clients/:clientId/PartnerSurvey/:instanceId/Submission',
        name: 'PartnerSurveySubmissionFormClient',
        component: PartnerSurveySubmissionForm,
        props: true,
        meta: {
            isUiShown: false,
            pageClass: 'psurvey-submission-form',
            pageTitle: 'Partner Survey',
        },
    },
];
